/**
 * Environment configuration
 * Centraliza todas las variables de entorno
 */

export const env = {
  // API
  apiUrl: (() => {
    const url = import.meta.env.VITE_API_URL || 'http://localhost:8000';
    // Force HTTPS for non-localhost URLs (production safety net)
    if (!url.includes('localhost') && url.startsWith('http://')) {
      return url.replace('http://', 'https://');
    }
    return url;
  })(),
  
  // App
  appName: import.meta.env.VITE_APP_NAME || 'AuriNot',
  appVersion: import.meta.env.VITE_APP_VERSION || '2.0.0',
  environment: import.meta.env.VITE_ENV || 'development',
  
  // Features
  enableDrive: import.meta.env.VITE_ENABLE_DRIVE === 'true',
  enableEmail: import.meta.env.VITE_ENABLE_EMAIL === 'true',
  
  // Demo mode (fallback data when API unavailable)
  demoMode: import.meta.env.VITE_DEMO_MODE === 'true',

  // Desarrollo local: abre todos los modulos sin consultar el plan ni el rol.
  // Solo surte efecto en dev; en un build de produccion se ignora, para que
  // el gating por plan siga intacto para los clientes.
  unlockAll: import.meta.env.VITE_UNLOCK_ALL === 'true' && import.meta.env.DEV,

  // Helpers
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
} as const;
